<div class="main-content">
  <div class="container-fluid">
    <div class="card">
<!--        <div class="card-header card/-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">badge</i>
        </div>
        <h4 class="card-title">Vendors List</h4>
      </div>  -->
      <div class="card-body">

        <div >
          <div >
            <div class="d-flex justify-content-between align-items-center">
                       
              <app-button-select 
                  [options]="optionsButtonSelect" 
                  [(selected)]="optionSelectMenuTrigger"
                  (selectedChange)="menuTriggerToShow($event)"
                  [label]="'Status'"
                  [widthPx]="138"
                  [specialWidth]="272">
              </app-button-select>
          
         
              <button class="gts-btn-primary btnWidth" matRipple (click)="newVendor()">
                  <span class="gts-btn-icon-left">add</span>
                  <span class="gts-btn-text">Vendor</span>
              </button>
          </div>
          <hr/>
<!--             <div class="col-md-12" style="text-align: right;">

              <button (click)="newVendor()" mat-raised-button class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">person_add</i>
                </span>
                New Vendor
              </button>

              &nbsp;&nbsp;

              <button type="button" class="btn btn-outline-{{activos === 1 ? 'info' : 'danger'}}"
                (click)="cambiarActivos()">
                <i class="fa fa-eye" aria-hidden="true"></i> Show {{activos === 1 ? 'Inactive' : 'Active'}} Vendors
              </button>
            </div> -->
          </div>
        </div>

        <div *ngIf="loading" style="text-align: center">
          <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
        </div>

<!--         <app-listvendors
          *ngIf="!loading && data.length > 0"
          [vendors]="data"
          [options]="options"
          (newOptions)="updateConfig($event)"
          (active)="activeVendor($event)"
        ></app-listvendors> -->
        <div style="position: relative">
          <section
            
          [ngClass]="getClass()"
            *ngIf="bulk.length > 0"
          >
            <div style="display: flex">
              <div class="title-actions">
                <b class="gts-btn-text">{{ bulk.length }} Selected: </b>
              </div>

            <button
            class="gts-btn-primary-outline-actions-end"
            matRipple
            [matTooltip]="activos === 1 ? 'Inactive' : 'Active'"
            (click)="DeleteMultiple()"
            [disabled]="bulk.length === 0"
          >
          <span class="gts-btn-icon">
            {{ activos === 1 ? 'close' : 'check' }}
          </span>
          </button>
                
            </div>
          </section>
          <div  [ngClass]="getClassConta()" >
        <dinamic-table
        *ngIf="!loading"
        [id]="'VendorTable'"
        [dbname]="'vendors'"
        [frontpaginate]="false"
        [data]="vendorData"
        [config]="options"
        [perPage]="itemsPorPagina"
        [page]="paginaActual"
        [total_items_count]="totalItems"
        [total_pages]="totalPaginas"
        (action_button)="action($event)"
        (newConfig)="updateConfig($event)"
        [columnfilters]="filtros"
        (buscar)="getOnlyVendor($event)"
        (rightClickAction)="handleRightClick($event)" 
        (toggleButtons)="onToggleButtons($event)"
        [bulk]="bulk"
    ></dinamic-table>
      </div>
    </div>
    </div>
  </div>
</div>